export default __webpack_public_path__ + "static/a1-2-401aa5d7a0e29b7e9097cb90f2ab0bed.jpg";